var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8507 1.79609C11.4816 2.88895 10.332 4.73395 8.28287 5.91702C6.23375 7.10008 4.06111 7.1732 3.43014 6.08033C2.79918 4.98747 3.94882 3.14246 5.99794 1.9594C8.04706 0.776341 10.2197 0.703222 10.8507 1.79609Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28493 8.05621C3.54686 8.05621 4.56986 9.97433 4.56986 12.3405C4.56986 14.7066 3.54686 16.6247 2.28493 16.6247C1.023 16.6247 1.03427e-07 14.7066 0 12.3405C-1.03426e-07 9.97433 1.023 8.05621 2.28493 8.05621Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43426 18.6106C4.06523 17.5178 6.23787 17.5909 8.28699 18.774C10.3361 19.957 11.4858 21.802 10.8548 22.8949C10.2238 23.9877 8.05118 23.9146 6.00206 22.7316C3.95294 21.5485 2.8033 19.7035 3.43426 18.6106Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1493 22.8925C12.5184 21.7996 13.668 19.9546 15.7171 18.7716C17.7663 17.5885 19.9389 17.5154 20.5699 18.6083C21.2008 19.7011 20.0512 21.5461 18.0021 22.7292C15.9529 23.9122 13.7803 23.9854 13.1493 22.8925Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7151 16.6199C20.4531 16.6199 19.4301 14.7018 19.4301 12.3357C19.4301 9.96957 20.4531 8.05145 21.7151 8.05145C22.977 8.05145 24 9.96957 24 12.3357C24 14.7018 22.977 16.6199 21.7151 16.6199Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5657 6.05836C19.9348 7.15122 17.7621 7.07811 15.713 5.89505C13.6639 4.71198 12.5142 2.86698 13.1452 1.77412C13.7762 0.681252 15.9488 0.75437 17.9979 1.93743C20.0471 3.12049 21.1967 4.96549 20.5657 6.05836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a6911ef4a19d26322cb7ea1bacc16745.svg";
export { ForwardRef as ReactComponent };